import React, { Component } from 'react';
import Select, { ActionMeta, GroupBase, MultiValue, SelectInstance, SingleValue } from 'react-select';
import { CustomerDataFields } from '../../interfaces/CustomerData/CustomerData';
import { FormFieldFunctions } from '../../interfaces/FormField/FormField';
import Option from '../../interfaces/Option/Option';
import Snapshot from '../../interfaces/Snapshot/Snapshot';
import { CustomDropdownIndicator } from '../FormFieldSelect/FormFieldSelectPartials';
import { formFieldSelectStylesForCustomerDataPage } from '../FormFieldSelect/FormFieldSelectStyles';
import FormFieldMultiSelectProps from './FormFieldMultiSelect.props';
import FormFieldMultiSelectState from './FormFieldMultiSelect.state';

export default class FormFieldMultiSelect extends Component<FormFieldMultiSelectProps, FormFieldMultiSelectState> implements FormFieldFunctions {
    private block: React.RefObject<HTMLDivElement>;
    private multiSelect: React.RefObject<SelectInstance<Option, true, GroupBase<Option>>>;
    private valueWasEmpty: boolean;

    constructor(props: FormFieldMultiSelectProps) {
        super(props);
        this.state = {
            values: this.props.values as string[] || [],
            preSelection: this.props.values && this.props.values.length > 0 ? true : false
        };

        this.block = React.createRef<HTMLDivElement>();
        this.multiSelect = React.createRef<SelectInstance<Option, true, GroupBase<Option>>>();
        this.valueWasEmpty = true;
        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.isValid = this.isValid.bind(this);
        this.toggleValidationError = this.toggleValidationError.bind(this);
        
    }

    updateAndNotify = () => {
        this.setState({
            values: this.props.values || [],
            preSelection: this.props.values && this.props.values.length > 0 ? true : false
        });

        // console.log('this.props.readOnly: ', this.props.readOnly);

        // console.log('this.props.isLoggedIn : ', this.props.isLoggedIn );
        // console.log('this.props.required: ', this.props.required);
        // console.log('this.isValid(): ', this.isValid());
        // console.log('value: ', this.getValue());
        // console.log('readOnly: ', this.props.readOnly);
        // console.log('valueEmpty: ', this.valueWasEmpty);
        // console.log('isDisabled2: ', this.props.readOnly || (this.props.isLoggedIn && this.getValue().length >= 1 && !this.valueWasEmpty) || !this.valueWasEmpty)
    }

    getSnapshotBeforeUpdate(prevProps: FormFieldMultiSelectProps): Snapshot {
        return { notifyRequired: prevProps.values !== this.props.values };
    }

    componentDidUpdate(prevProps: FormFieldMultiSelectProps, prevState: FormFieldMultiSelectState, snapshot: Snapshot) {
        if (snapshot.notifyRequired) {
            this.updateAndNotify();
        }
        if (prevProps.isLoggedIn !== this.props.isLoggedIn) {
            console.log('time is now')
            this.setState({
                preSelection: !this.props.isLoggedIn ? false : (this.props.values && this.props.values.length >= 1 ? true : false)
            });
        }
    }

    isValid() {
        if (this.props.required && this.state.values.length === 0) {
            return false;
        }

        return true;
    }

    toggleValidationError(show: boolean) {
        if (show) {
            this.block.current?.parentElement?.classList.add('form__field--error');
        } else {
            this.block.current?.parentElement?.classList.remove('form__field--error');
        }
    }

    handleSelectChange(newValue: MultiValue<Option> | SingleValue<Option>, actionMeta: ActionMeta<Option>) {
        this.setState({
            values: (newValue as MultiValue<Option>).map((option: Option) => {
                return option.value;
            }),
        });
    }

    getValue() {
        return this.state.values;
    }

    render(): React.ReactNode {
        return (
            
            <div data-testid="FormFieldMultiSelect"
                className={
                    "select"
                    + (this.state.values.length !== 0 ? " select--option-selected" : "")
                }
                ref={this.block}>
                <div className="select__inner">
                    <div className="select__content">
                        {
                            this.props.label &&
                            <label className="select__label" htmlFor={this.props.id}>{this.props.label}</label>
                        }
                        <Select
                            id={this.props.id}
                            name={this.props.id}
                            value={this.props.options.filter(option => this.state.values.findIndex(value => value === option.value) >= 0)}
                            options={this.props.options}
                            placeholder={this.props.label}
                            // defaultMenuIsOpen={true} // for debug purposes
                            noOptionsMessage={() => "Keine Optionen"}
                            isDisabled={this.props.readOnly || (this.props.isLoggedIn && this.getValue().length >= 1 && this.state.preSelection && this.props.required)}
                            closeMenuOnSelect={false}
                            isMulti={true}
                            onChange={this.handleSelectChange}
                            menuPortalTarget={document.body}
                            styles={formFieldSelectStylesForCustomerDataPage}
                            ref={this.multiSelect}
                            components={{
                                DropdownIndicator: CustomDropdownIndicator,
                                // SelectContainer: CustomSelectContainer
                            }}
                        />
                    </div>
                    {this.props.id === CustomerDataFields.MEMBERSHIPS &&
                        <div className="select-multi__hint-container">
                            <span className="select-multi__hint">{this.props.hint}</span>
                        </div>
                    }
                </div>
                {/* <div className="select-multi__multi-option-output">
                    <div className="select-multi__multi-option-container">
                        <div className="chip-group">
                            <div className="chip-group__chip-list">
                            </div>
                        </div>
                    </div>
                </div>
                <div className="select-multi__backdrop"></div> */}
            </div>
        );
    }
}
